// extracted by mini-css-extract-plugin
export default {"hardArea":"HardArea_hardArea__e5mjK"};